import { render, staticRenderFns } from "./VSearchInput.vue?vue&type=template&id=0eddbf6c&"
import script from "./VSearchInput.vue?vue&type=script&lang=ts&"
export * from "./VSearchInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports